import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Avatar, Box, Typography, Chip } from "@mui/material";
import styles from "./style";
import CustomPagination from "../../../../../components/CustomPagination";
import { formatDate } from "../../../../../utils/DateFormat";


const DeductionList = ({ data, page, setPage, total }) => {

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getChipStyles = (status) => {
    if (!status) {
      return {
        backgroundColor: "default",
        color: "inherit"
      };
    }
    const statusLower = status.toLowerCase();
    if (statusLower === "paid") {
      return {
        backgroundColor: "#cef5d6",
        color: "#126300"
      };
    }
    if (statusLower === "due") {
      return {
        backgroundColor: "#f01a0a",
        color: "#fff"
      };
    }
    return {
      backgroundColor: "default",
      color: "inherit"
    };
  };
  
  return (
    <>
      <TableContainer>
        <Table sx={styles.table}>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Date</TableCell>
              <TableCell sx={styles.TableHead}>Processed Date</TableCell>
              <TableCell sx={styles.TableHead}>Mode</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Total Amount</TableCell>
              <TableCell sx={styles.TableHead}>Paid Amount</TableCell>
              <TableCell sx={styles.TableHead}>Left Balance</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tabledata}>{(item?.fromDate && item?.toDate) ? `${formatDate(item.fromDate)}-${formatDate(item.toDate)}` : '-'}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.processDate ? formatDate(item.processDate) : '-'}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.paymentMethod}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.calculatedAmount}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.totalAmount ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.paidAmount ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>{item?.leftBalance ?? "-"}</TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Chip
                      label={item?.status || "-"}
                      size="small"
                      sx={{
                        fontWeight: 500,
                        textTransform: "capitalize",
                        ...getChipStyles(item?.status)
                      }}
                    />
                  </TableCell>
                </TableRow>
              )))}
          </TableBody>
        </Table>

        {data &&
          <CustomPagination
            pageCount={total}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            totalItems={data.length}
          />}


      </TableContainer>


    </>);
};
export default DeductionList;
